import { useContext } from "react";

// ----> ASSETS IMPORTATION
import slogan_es from "../../assets/slogan-es.png";
import slogan_en from "../../assets/slogan-en.png";


// language context importation
import { LangContext } from "../../context/LangContext.jsx";



// react translation
import { useTranslation } from "react-i18next";






export const LoadingComp = () => {

  // react translation
  const [t] = useTranslation("global");

  // GET the lang context
  const { lang } = useContext(LangContext);

  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      position: "fixed",
      backgroundColor: "white",
      bottom: "0",
      opacity: "0.8",
      height: "100%",
      left: "0",
      top: "0",
      right: "0",
      width: "100vw",
      zIndex: "4"
    }}>
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}>
        <svg style={{
          animation: "spin 1s linear infinite",
          height: "20vw",
          width: "20vw",

        }} viewBox="0 0 50 50">
          <circle
            style={{
              fill: "none",
              stroke: "#074f6b",
              strokeWidth: "0.1rem",
              strokeLinecap: "round",
              animation: "dash 2.5s ease-in-out infinite"
            }}
            cx="25"
            cy="25"
            r="20" />
        </svg>
        <h4 style={{ color: "var(--first-color)" }}>
          {t("SignUpComp.cargando")}
        </h4>
        <div style={{ display: "flex", justifyContent: "center" }}>
          {
            lang === "es" ?
              (<img className="slogan" src={slogan_es} alt="Global Slogan" />) :
              (<img className="slogan" src={slogan_en} alt="Global Slogan" />)
          }
        </div>
      </div>
    </div>
  );
};